/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCreateCheckoutSessionResponseFromDiscriminatorValue, createHttpValidationProblemDetailsFromDiscriminatorValue, createIErrorFromDiscriminatorValue, serializeCreateCheckoutSessionRequest, serializeCreateCheckoutSessionResponse, type CreateCheckoutSessionRequest, type CreateCheckoutSessionResponse, type HttpValidationProblemDetails, type IError } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /billing/checkout-sessions
 */
export interface CheckoutSessionsRequestBuilder extends BaseRequestBuilder<CheckoutSessionsRequestBuilder> {
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CreateCheckoutSessionResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     post(body: CreateCheckoutSessionRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<CreateCheckoutSessionResponse | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CreateCheckoutSessionRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const CheckoutSessionsRequestBuilderUriTemplate = "{+baseurl}/billing/checkout-sessions";
/**
 * Metadata for all the requests in the request builder.
 */
export const CheckoutSessionsRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: CheckoutSessionsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCreateCheckoutSessionResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreateCheckoutSessionRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
